import { Form, Divider } from 'antd';

import CheckboxMultiSelect from '@/components/CheckboxMultiSelect';
import HeaderWithHelp from '@/components/HeaderWithHelp';
import useTripInclusionsExclusions from '@/hooks/useTripInclusionsExclusions';
import TripService from '@/services/TourServices/TripService';
import CreateSection from '@/components/CreateInclExclSection';

const question = 'What is this?';
const answer = 'Lorem ipsum dolor sit amet...';

const Inclusions = ({ initialInclusions }) => {
    const { data, mutate } = useTripInclusionsExclusions();

    return (
        <div className="inclusions">
            <HeaderWithHelp
                title="Inclusions"
                question={question}
                answer={answer}
            />

            <Divider />

            <Form.Item name="inclusions">
                <CheckboxMultiSelect
                    options={data?.data.inclusions}
                    labelParamName="name"
                    valueParamName="id"
                    initialCheckedList={initialInclusions}
                />
            </Form.Item>

            <CreateSection
                data={data}
                mutate={mutate}
                buttonText="Add New Inclusion Item"
                addNewItem={TripService.addNewInclusion}
                tourcategory={1}
            />
        </div>
    );
};

export default Inclusions;
